import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import type { DebtCollectionTaskEventTypeFindManyQueryInterface } from '@zaoblako/shared/modules/debts/dtos/debt-collection-task-event-type/debt-collection-task-event-type-find-many-query.dto';
import type { DebtCollectionTaskEventTypePageInterface } from '@zaoblako/shared/modules/debts/dtos/debt-collection-task-event-type/debt-collection-task-event-type-page.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';

@Injectable({
  providedIn: 'root'
})
export class DebtCollectionTaskEventTypeService extends BaseService {
  protected baseUrl = '/debts/debt-collection/event-type';

  public findMany(
    query?: DebtCollectionTaskEventTypeFindManyQueryInterface
  ): Observable<DebtCollectionTaskEventTypePageInterface> {
    return this.http.get<DebtCollectionTaskEventTypePageInterface>(this.baseUrl, {
      params: query ? this.objectToHttpParams(query) : {}
    });
  }
}
